var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"sa-content"},[(_vm.loading)?_c('div',[_c('img',{staticClass:"sa-loader sa-loader-top",attrs:{"src":require("../../assets/img/loader.svg"),"alt":"loader"}})]):_c('div',[_c('div',{staticClass:"sa-card-large"},[_c('labtech-details',{attrs:{"d":_vm.details}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }